<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { FormField } from '@drama/ui'

const props = defineProps({
  label: { type: String, required: true },
  hint: { type: String, default: '' },
  error: { type: String, default: '' },
  /** Content requirements describe validation readiness, not draft-save restrictions. */
  required: { type: Boolean, default: false },
  notApplicable: { type: Boolean, default: false },
})

const { t } = useI18n()
const requirement = computed(() => props.notApplicable ? 'notApplicable' : props.required ? 'required' : 'optional')
</script>

<template>
  <FormField
    :label="t(`novelStudio.requirements.${requirement}Label`, { label })"
    :hint="hint"
    :error="error"
    :data-requirement="requirement"
  >
    <slot />
  </FormField>
</template>
